// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Irh-","left":"styles_left__1uRuH","right":"styles_right__3uUyN","alert":"styles_alert__3YMK7"};